export enum Permissions {
  UserManagement = 1,
  SystemManagement = 2,
  PatientManagement = 3,
  ClaimsManagement = 5,
  PaymentManagement = 6,
  WorkflowManagement = 7,
  ChecklistLibrary = 9,
  TaskLibrary = 10,
  ProblemLibrary = 11,
  Assessments = 12,
  LookupEntities = 13,
  PermissionsView = 14,
  PatientViewAll = 15,
  TaskViewAll = 16,
  PatientCreate = 17,
  PatientIntakeView = 18,
  PatientIntakeEdit = 19,
  PatientPersonalView = 20,
  PatientPersonalEdit = 21,
  PatientCommunicationView = 26,
  PatientCommunicationEdit = 27,
  PatientTasksView = 28,
  PatientTasksEdit = 29,
  PatientPhasesView = 30,
  PatientPhasesEdit = 31,
  PatientProvidersView = 34,
  PatientProvidersEdit = 35,
  PatientAssessmentsView = 36,
  PatientAssessmentsEdit = 37,
  PatientDocumentsView = 38,
  PatientDocumentsEdit = 39,
  PageHelpEdit = 40,
  AdmissionEdit = 41,
  PatientCareplanView = 42,
  PatientCareplanEdit = 43,
  PatientBillingView = 44,
  PatientBillingEdit = 45,
  TransactionManagement = 47,
  ScreeningOperationalDecisionAdd = 51,
  ScreeningOperationalDecisionEdit = 52,
  ScreeningClinicalDecisionAdd = 53,
  ScreeningClinicalDecisionEdit = 54,
  ScreeningView = 55,
  TrackerAdministration = 56,
  PatientIntakeExpectedAdmissionEdit = 57,
  TaskEditSystemSbar = 58,
  PatientTasksAdmin = 59,
  ViewCaseload = 60,
  InactivateTaskWithQualityMetric = 61,
  TerminationReasonEdit = 62,
  PatientAdmissionView = 63,
  AddEditProviderUser = 64,
  CreateEditAnchorProviders = 65,
  RemovePCNAssignment = 67,
  ScreeningStatusEdit = 68,
  HighDollarThresholdEdit = 69,
  ScreeningIncludeExcludeOnError = 70,
  PatientIntakeBypassValidation = 71,
  PhasesAbilityToEditThroughEpisodeLifetime = 72,
  ClaimsRelatedDataEdit = 74,
  ScreeningOperationalExclude = 75,
  ScreeningClinicalExclude = 76,
  UploaderTool = 77,
  ReactivateTerminatedEpisodes = 78,
  TimelyFilingEdit = 79,
  ViewClinicalService = 80,
  EditClinicalService = 81,
  AdminEditAdmission = 82,
  PatientBillingAdmin = 83,
  PatientDocumentsAdmin = 84
}

export interface IRolePermission {
  Id: number
  Name: string
  Roles: string[]
}
